import { ReactNode } from "react";
import { FilterMenuProps } from "./filter-menu/FilterMenu";
import { KeywordSearchProps } from "./keyword-search/KeywordSearch";
import { SearchBarBase } from "./search-bar-base/SearchBarBase";
import { SearchBarWithSuggestions } from "./search-bar-with-suggestions/SearchBarWithSuggestions";

export interface SearchBarProps {
    /**
     * props for the filter menu component
     */
    filterMenuProps?: FilterMenuProps;

    /**
     * props for the keyword-search component
     */
    keywordSearchProps: KeywordSearchProps;

    /**
     * buttons to render on the right end of the bar
     */
    buttons?: ReactNode[];
    /**
     * buttons to render on the left end of the bar
     */
    leftButtons?: ReactNode[];

    /**
     * should search input take full screen width
     */
    fullWidth?: boolean;

    /**
     * should we show search terms suggestions
     */
    showSuggestions?: boolean;
}

/**
 * Search bar with keyword search, search settings and filters modal button.
 */
export function SearchBar(props: SearchBarProps) {
    if (props.showSuggestions) {
        return <SearchBarWithSuggestions {...props} />;
    }
    return <SearchBarBase {...props} />;
}

export default SearchBar;
